function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { InMemoryCache } from "@apollo/client";
import { reportRuntimeError } from "../telemetry/internalReporting";
class MemoryCache {
    watch({ query, variables, callback }) {
        const cleanup = this.cache.watch({
            query,
            variables,
            optimistic: true,
            callback: (diff)=>{
                if (diff.complete) {
                    callback(diff.result || null);
                }
            }
        });
        return cleanup;
    }
    readQuery({ query, variables }) {
        try {
            return this.cache.readQuery({
                query,
                variables
            });
        } catch (e) {
            reportRuntimeError(this.observabilityFns, e, 'Could not perform cache.read operation');
            throw new Error('Could not perform cache.read operation');
        }
    }
    writeQuery({ query, variables, data }) {
        this.cache.writeQuery({
            query,
            variables,
            data
        });
    }
    writeMutation({ mutation, variables, data }) {
        this.cache.write({
            result: data,
            dataId: 'ROOT_MUTATION',
            query: mutation,
            variables
        });
        // We have no use for the mutation result in the cache atm, so we remove it entirely
        // This might change when we get to optimistic updates
        this.cache.evict({
            id: 'ROOT_MUTATION'
        });
    }
    constructor(observabilityFns, cache){
        _define_property(this, "cache", void 0);
        _define_property(this, "observabilityFns", void 0);
        this.cache = cache || new InMemoryCache();
        this.observabilityFns = observabilityFns;
    }
}
// Wrapper around Apollo's InMemoryCache to be able to switch to other
// implementations if needed. We should not leak any types coming over from
// apollo.
export { MemoryCache as default };

//# sourceMappingURL=MemoryCache.js.map